(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/article-list/assets/javascripts/article_list.js') >= 0) return;  svs.modules.push('/widgets/article-list/assets/javascripts/article_list.js'); "use strict";

(function (svs) {
  'use strict';

  var logger = new svs.core.log.Logger('widget:article_list');
  svs.widget = svs.widget || {};
  svs.widget.article_list = svs.widget.article_list || {};

  svs.widget.article_list.fetchData = function (options, data, callback) {
    try {
      return svs.content.simple_article.contentLoader.loadArticles(options, function (err, model) {
        if (err) {
          logger.warn("Error loading article widget content: ".concat(err.toString()));
          callback(null);
        } else {
          data.articles = model;
          callback(null, data);
        }
      });
    } catch (e) {
      logger.error("Error loading widget: ".concat(e.toString()));
      callback(e);
    }
  };
})(svs);
 })(window);